import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Ancient_Civilizations_-_Mesopotamia.png';

export default function HistoryPageMesoamericaGo() {
  return (
    <QuizPage
      title="History: Ancient Mesopotamia"
      subTopic="Mesopotamia"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-Mesopotamia"
    />
  );
}
